import {
  WebGLRenderTarget,
  OrthographicCamera,
  Scene as ThreeScene,
  PlaneGeometry,
  Mesh,
  ShaderMaterial
} from 'three';
import { gsap } from 'gsap';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import { TRANSITION_VERTEX } from './shaders/transition-vertex';
import { TRANSITION_FRAGMENT } from './shaders/transition-fragment';

export default class TransitionController {
  static renderTarget = null;
  static material = null;
  static quadScene = null;
  static quadCamera = null;

  static init() {
    this.renderTarget = new WebGLRenderTarget(WebGLSketch.size.x, WebGLSketch.size.y);

    this.material = new ShaderMaterial({
      uniforms: {
        tDiffuse: { value: this.renderTarget.texture },
        progress: { value: 0 },
        scale: { value: 2.8 },
        smoothness: { value: 0.13 },
        seed: { value: Math.random() * 100 }
      },
      vertexShader: TRANSITION_VERTEX,
      fragmentShader: TRANSITION_FRAGMENT,
      transparent: true,
      depthTest: false,
      depthWrite: false
    });

    this.quadCamera = new OrthographicCamera(-1, 1, 1, -1, 0, 1);
    this.quadScene = new ThreeScene();
    this.quadScene.add(new Mesh(new PlaneGeometry(2, 2), this.material));
  }

  // ─── Render passes (crida des de Main.loop) ──────────────────────────────
  // Captura el BGSphere (layer 1) i renderitza el dissolve com a fons.
  // La resta d'objectes es renderitzen a Main.loop via WebGLSketch.renderScene().

  static loop() {
    if (!this.material) return;

    const renderer = WebGLSketch.renderer;
    const scene = WebGLSketch.scene;
    const camera = WebGLSketch.camera;

    // Pass 1 — capture BGSphere (layer 1) → RT
    camera.layers.set(1);
    renderer.setRenderTarget(this.renderTarget);
    renderer.clear();
    renderer.render(scene, camera);
    renderer.setRenderTarget(null);

    // Pass 2 — dissolve quad (BGSphere texture) → canvas com a fons
    renderer.autoClear = true;
    renderer.render(this.quadScene, this.quadCamera);
    renderer.autoClear = false;
    camera.layers.enableAll();
  }

  // ─── API pública ─────────────────────────────────────────────────────────

  // Control directe del progress (sense animació, per scroll)
  static setProgress(value) {
    if (!this.material) return;
    gsap.killTweensOf(this.material.uniforms.progress);
    this.material.uniforms.progress.value = value;
  }

  static show(duration = 1, delay = 0, ease = 'power2.Out') {
    if (!this.material) return;
    this.material.uniforms.seed.value = Math.random() * 100;
    gsap.killTweensOf(this.material.uniforms.progress);
    gsap.to(this.material.uniforms.progress, { value: 1, duration, delay, ease });
  }

  static hide(duration = 1, delay = 0, ease = 'power2.Out') {
    if (!this.material) return;
    this.material.uniforms.seed.value = Math.random() * 100;
    gsap.killTweensOf(this.material.uniforms.progress);
    gsap.to(this.material.uniforms.progress, { value: 0, duration, delay, ease });
  }

  // ─── Resize / Dispose ────────────────────────────────────────────────────

  static resize() {
    if (!this.renderTarget) return;
    this.renderTarget.setSize(WebGLSketch.size.x, WebGLSketch.size.y);
  }

  static dispose() {
    if (this.renderTarget) { this.renderTarget.dispose(); this.renderTarget = null; }
    if (this.material) { this.material.dispose(); this.material = null; }
  }
}
